module.exports = __webpack_public_path__ + "static/media/21ECLAC23.cae30f27.jpg";